import { MediaQuery } from 'svelte/reactivity';

export type BreakpointName = 'mini' | 'small' | 'nav' | 'medium' | 'large';

export class BreakpointService {
    /**
     * Spiegelt $breakpoints aus styles/_defintions.scss.
     * Wird dort ein Wert geändert, muss er hier mitgezogen werden.
     */
    private static readonly BaseFont = 16;
    private static readonly Breakpoints: Record<BreakpointName, number> = {
        mini: 310,
        small: 480,
        nav: 592,
        medium: 768,
        large: 1024,
    };

    /** Über alle Instanzen geteilt, damit jede Grösse nur einen matchMedia-Listener bekommt. */
    private static readonly Queries: Partial<Record<BreakpointName, MediaQuery>> = {};

    /**
     * Reaktives Gegenstück zu den greaterX()-Mixins, beispielsweise greater('large') === @include mixins.greaterLarge().
     * Nur benutzen, wenn CSS allein nicht reicht - etwa wenn eine Komponente je nach Größe an einer
     * anderen Stelle im DOM hängen muss, statt nur ein-/ausgeblendet zu werden.
     */
    public greater(name: BreakpointName): MediaQuery {
        return (BreakpointService.Queries[name] ??= new MediaQuery(this.buildQuery(BreakpointService.Breakpoints[name])));
    }

    public isGreater(name: BreakpointName): boolean {
        return this.greater(name).current;
    }

    /** Identisch zu mixins.mediaQueryPixelByPixel() aus styles/_mixins.scss. */
    private buildQuery(px: number): string {
        const Rem = px / BreakpointService.BaseFont;
        return `(min-width: ${Rem.toString()}rem), (min-width: ${px.toString()}px)`;
    }
}
